import { useState, useEffect } from "react";

// short stub; the real letter lives in public/message.txt
const FALLBACK_MESSAGE = "Happy 4 months, Sarvin";

export default function useMessage() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    let cancelled = false;

    fetch(`${process.env.PUBLIC_URL}/message.txt`)
      .then((res) => {
        if (!res.ok) throw new Error("failed to load message");
        return res.text();
      })
      .then((text) => {
        if (!cancelled) setMessage(text);
      })
      .catch(() => {
        if (!cancelled) setMessage(FALLBACK_MESSAGE);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return message;
}
